import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import './Fallback.css';
import './MemoryDisplay.css';
import axios from 'axios';
const apiUrl = process.env.REACT_APP_END_POINT
import styled from "styled-components";

const toneStyles = {
  Sentimental: { background: "#fef3bd", text: "#795548", border: "#ffcc80" },
  Humorous: { background: "#dcedc8", text: "#33691e", border: "#aed581" },
  Reflective: { background: "#cfd8dc", text: "#263238", border: "#90a4ae" },
};

const MemoryDisplay = () => {
  const { id } = useParams();
  const [memoryData, setMemoryData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [tone, setTone] = useState("Sentimental");
  const [likes, setLikes] = useState(0);
  const [liked, setLiked] = useState(false);

  const handleShare = async () => {
      if (navigator.share) {
        if (window.gtag) {
          window.gtag('event', 'click', {
            event_category: 'share',
            event_label: 'memory',
          });
        }
        try {
          await navigator.share({
            title: `Memory with ${memoryData.recipient}`,
            text: memoryData.memory,
            url: window.location.href,
          });
        } catch (error) {
          console.error('Error sharing memory:', error);
        }
      } else {
        alert('Sharing not supported on this device');
      }
    };

  const handleLike = () => {
      if (!liked) {
        if (window.gtag) {
          window.gtag('event', 'click', {
            event_category: 'like',
            event_label: 'memory',
          });
        }
        setLiked(true);
        setLikes((prevLikes) => prevLikes + 1);
        localStorage.setItem(`liked-${id}`, true);

        // Optional: Send like update to backend
        axios.post(`${apiUrl}/updateLikes`, { id }).catch((err) => {
          console.error("Failed to update likes:", err);
        });
      }
    };
    

  useEffect(() => {
    const getMemoryData = async () => {
      const req = { id: id }
      try {
        const response = await axios.post(`${apiUrl}/fetchMessage/`,req);
        const data = response.data;
        setMemoryData(data);
        setTone(response.data.tone);

        // Fetch like status and count from localStorage
        const isLiked = localStorage.getItem(`liked-${id}`);
        if (isLiked) setLiked(true);
        setLikes(data.likes || 0); // Default to 0 if not available
      } catch (err) {
        setError('Failed to load message. Please try again later.');
      }
    };
    getMemoryData();
  }, [id]);

  const toneStyle = toneStyles[tone] || toneStyles.Sentimental;

  return  ( <Container style={{ backgroundColor: toneStyle.background }}>
      {memoryData ? (
      <>
          <Header style={{ color: toneStyle.text }}>A {tone} Memory</Header>
          <CardContainer>
            <Card style={{ borderColor: toneStyle.border, color: toneStyle.text }}>
              <MemoryText>{memoryData?.memory}</MemoryText>
            </Card>
            <LikeContainer onClick={handleLike} style={{ backgroundColor: toneStyle.background }}>
              <HeartIcon>{liked ? "❤️" : "🤍"}</HeartIcon>
              <LikeCount>{likes}</LikeCount>
            </LikeContainer>
          </CardContainer>
          <Actions>
            <ActionButton style={{ background: toneStyle.text, color: toneStyle.background }} onClick={() => navigate("/")}>
              Generate New 
            </ActionButton>
            <ActionButton style={{ background: toneStyle.text, color: toneStyle.background }} onClick={handleShare}>
              Share
            </ActionButton>
          </Actions>
          <Footer>Treasure your memories!</Footer>
        </>
    ) : error ? (
      <div className="no-message-container">
        <h1>Oops! We couldn't find that message.</h1>
        <p>Don’t worry, you can generate a new one right away.</p>
        <button onClick={() => navigate("/")}>Generate New Message</button>
      </div>
    ) : (
      <p>Loading...</p>
    )}
    </Container>
  );
};

export default MemoryDisplay;


// Styled Components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  min-height: 100vh;
`;

const Header = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
`;

const Card = styled.div`
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid;
  max-width: 600px;
  text-align: center;
`;

const CardContainer = styled.div`
  position: relative;
  max-width: 600px;
`;

const MemoryText = styled.p`
  font-size: 18px;
  line-height: 1.6;
`;

const Actions = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 10px;
`;

const ActionButton = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
`;

const Footer = styled.p`
  margin-top: 20px;
  font-size: 14px;
  color: #666;
`;

const ErrorMessage = styled.div`
  font-size: 18px;
  color: red;
  text-align: center;
`;


const LikeContainer = styled.div`
  position: absolute;
  bottom: -15px;
  right: -15px;
  background-color: #fff;
  border-radius: 50px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.3s;
  &:hover {
    transform: scale(1.1);
  }
`;

const HeartIcon = styled.span`
  font-size: 18px;
  margin-right: 6px;
`;

const LikeCount = styled.span`
  font-size: 16px;
  color: #333;
`;
